module.exports = __webpack_public_path__ + "img/device_bright.4053a789.jpg";